import { createContext, useContext } from 'react';

/**
 * Carries the popup opened on the user gesture by `useHeadlessOAuthLauncher`
 * down to the headless flow, without exposing it as a public prop on the modal
 * components. The popup is internal plumbing; consumers control the flow only
 * through `mode` / `appName`.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const HeadlessOAuthWindowContext = /*#__PURE__*/createContext(null);
export function HeadlessOAuthWindowProvider({
  oAuthWindow,
  children
}) {
  return /*#__PURE__*/_jsx(HeadlessOAuthWindowContext.Provider, {
    value: oAuthWindow,
    children: children
  });
}
export function useHeadlessOAuthWindow() {
  return useContext(HeadlessOAuthWindowContext);
}